import { __decorate, __metadata } from "tslib";
import { AppRequest } from '@core/shared/app-request';
import { AppRequestMethod } from '@core/shared/request';
import { EditorDefinition, Expose, Model, ModelId } from '@core/shared/model';
import { MaintenanceSettings } from '../models/maintenance-settings';
let UpdateMaintenanceSettingsResponse = /*#__PURE__*/(() => {
  let UpdateMaintenanceSettingsResponse = class UpdateMaintenanceSettingsResponse extends MaintenanceSettings {};
  UpdateMaintenanceSettingsResponse = __decorate([ModelId("UpdateMaintenanceSettingsResponse") // auto-generated by generate-model-ids
  ], UpdateMaintenanceSettingsResponse);
  return UpdateMaintenanceSettingsResponse;
})();
export { UpdateMaintenanceSettingsResponse };
let UpdateMaintenanceSettingsRequest = /*#__PURE__*/(() => {
  let UpdateMaintenanceSettingsRequest = class UpdateMaintenanceSettingsRequest extends Model {
    static {
      this.Response = UpdateMaintenanceSettingsResponse;
    }
  };
  __decorate([Expose(), __metadata("design:type", Boolean)], UpdateMaintenanceSettingsRequest.prototype, "announcementEnable", void 0);
  __decorate([Expose(), __metadata("design:type", String)], UpdateMaintenanceSettingsRequest.prototype, "announcementText", void 0);
  __decorate([Expose(), __metadata("design:type", Date)], UpdateMaintenanceSettingsRequest.prototype, "announcementTime", void 0);
  __decorate([Expose(), __metadata("design:type", Boolean)], UpdateMaintenanceSettingsRequest.prototype, "maintenanceMode", void 0);
  __decorate([Expose(), __metadata("design:type", String)], UpdateMaintenanceSettingsRequest.prototype, "maintenanceModeText", void 0);
  UpdateMaintenanceSettingsRequest = __decorate([AppRequest('admin/maintenance', 'update-settings', {
    httpMethod: AppRequestMethod.POST
  }), EditorDefinition('admin', {}, {
    allowAllExposed: true,
    useAppRequest: true
  }), ModelId("UpdateMaintenanceSettingsRequest") // auto-generated by generate-model-ids
  ], UpdateMaintenanceSettingsRequest);
  return UpdateMaintenanceSettingsRequest;
})();
export { UpdateMaintenanceSettingsRequest };